import axiosInstance from "./axios";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const updatePipedriveInfo = async (
  bearerToken: string,
  payload: {
    companyId?: number;
    userId?: number;
    pipeOrganizationId?: number;
    pipePersonId?: number;
  },
): Promise<void> => {
  try {
    await axiosInstance.post(
      `${apiUrl}/Admin/contracts/poke`,
      {},
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
        params: {
          ...(payload.userId !== undefined && { userId: payload.userId }),
          ...(payload.companyId !== undefined && {
            companyId: payload.companyId,
          }),
          ...(payload.pipeOrganizationId !== undefined && {
            pipeOrganizationId: payload.pipeOrganizationId,
          }),
          ...(payload.pipePersonId !== undefined && {
            pipePersonId: payload.pipePersonId,
          }),
        },
      },
    );
  } catch (error) {
    console.error("Failed to update info from Pipedrive:", error);
    throw error;
  }
};
